export default {
  // Header
  about: 'About',
  projects: 'Projects',
  contact: 'Contact',
  
  // Hero Section
  heroTitle: 'Immersive Gaming Experiences',
  heroTitleHighlight: 'From the Middle East.',
  heroDescription: 'DeepQuest creates innovative games that captivate players worldwide with cutting-edge technology and storytelling.',
  
  // About Section
  aboutTitle: 'DeepQuest',
  aboutTitleSuffix: ', a pioneering game studio',
  aboutDescription: 'We craft immersive gaming experiences that blend rich storytelling with cutting-edge technology. Our passion is creating worlds that captivate players globally, bringing unique perspectives and innovative gameplay that push the boundaries of interactive entertainment.',
  
  // Projects Section
  featuredGame: 'Featured',
  game: 'Game',
  oasisRichman: 'Oasis Richman',
  gameDescription: 'Experience the ultimate Monopoly-style social strategy mobile game set in a vibrant desert oasis. Build your empire, trade properties, and compete with friends in this exciting blend of classic board game mechanics and modern mobile gaming.',
  strategicGameplay: 'Strategic Gameplay',
  strategicGameplayDesc: 'Master the art of property trading and resource management',
  socialExperience: 'Social Experience',
  socialExperienceDesc: 'Connect and compete with players worldwide',
  richRewards: 'Rich Rewards',
  richRewardsDesc: 'Unlock achievements and collect exclusive items',
  playNow: 'Play Now!',
  
  // Contact Section
  contactTitle: 'Contact',
  contactTitleHighlight: 'DeepQuest',
  contactTitleSuffix: 'to learn more',
  contactDescription: 'Ready to transform your vision into reality? Let\'s discuss how our innovative gaming solutions can elevate your next project.',
  yourName: 'Your Name',
  yourEmail: 'Your Email',
  yourMessage: 'Your Message',
  sendMessage: 'Send Message',
  sending: 'Sending...',
  messageSent: 'Message sent successfully!',
  messageFailed: 'Failed to send message. Please try again.',
  fillAllFields: 'Please fill in all fields.',
  
  // Common
  learnMore: 'Learn More',
  
  // Language
  language: 'Language',
  english: 'English',
  arabic: 'العربية'
};
